import React from "react";

const STORAGE_KEY = "portfolio-language";
const SUPPORTED_LANGUAGES = ["en", "ar"];

let activeLanguage = "en";

const arabicTranslations = {
  "A workspace combining software development and chemistry":
    "مشهد لمكتب يجمع تطوير البرمجيات والكيمياء",
  "Programming Skills": "المهارات البرمجية",
  "Software application development": "تطوير التطبيقات البرمجية",
  "Database design": "هيكلة قواعد البيانات",
  "Programming languages & technologies: JavaScript, PHP, Node.js, Bun, MySQL, SQLite3":
    "لغات وتقنيات البرمجة: JavaScript، PHP، Node.js، Bun، MySQL، SQLite3",
  "Website penetration testing and security": "اختبار اختراق المواقع وتأمينها",
  "Academic Skills": "المهارات الأكاديمية",
  "Data collection": "جمع البيانات",
  "Statistical analysis and data interpretation":
    "التحليل الإحصائي وتفسير البيانات",
  "Sample and solution preparation": "تحضير العينات والمحاليل",
  "Open on Telegram": "فتح في تيليجرام",
  "Experience & Practical Projects": "الخبرات والمشاريع العملية",
  "Professional Experience": "الخبرات العملية",
  "October 2024 — Present": "أكتوبر 2024 — حتى الآن",
  "AI & Model Training": "الذكاء الاصطناعي وتدريب النماذج",
  "AI model training": "تدريب نماذج الذكاء الاصطناعي",
  "Web Security": "أمن المواقع",
  "Penetration testing": "اختبار الاختراق",
  "Website security": "تأمين المواقع",
  "Chemistry & Scientific Research": "الكيمياء والبحث العلمي",
  "Laboratory work": "العمل بالمختبرات",
  "Scientific research skills": "مهارات البحث العلمي",
  "Study of chemical compounds": "دراسة المركبات الكيميائية",
  "I turn repetitive tasks into software that saves you time":
    "أحوّل مهامك المتكررة إلى برامج تختصر وقتك",
  "Share your workflow, requirements, and the forms and records you use.":
    "استلام تفاصيل عملك واحتياجاتك، والاطّلاع على النماذج والسجلات التي تستخدمها.",
  "I study each step, document the details, and define the most suitable solution for your work.":
    "دراسة خطوات العمل وتوثيق جميع التفاصيل، ثم تحديد الحل الأنسب لطبيعة عملك.",
  "I build and test a digital product that simplifies your tasks, then refine it with your feedback.":
    "تطوير برنامج رقمي يبسّط مهامك، واختباره وتحسينه معك ليُلائم احتياجاتك بأفضل صورة.",
  "Modern, responsive websites and web applications tailored to your business.":
    "تطوير مواقع وتطبيقات ويب حديثة ومتجاوبة تناسب احتياجات عملك.",
  "Mobile applications for Android and iOS.":
    "تطوير تطبيقات موبايل لأنظمة Android وiOS.",
  "Specialized tools built for your specific tasks and workflows.":
    "بناء أدوات متخصصة ومخصّصة لتنفيذ مهامك وتسهيل إجراءات عملك.",
  "Environment & Hosting Management": "إدارة البيئات والاستضافة",
  "Managing Linux servers and preparing application deployment environments.":
    "إدارة خوادم Linux وتجهيز بيئات نشر التطبيقات وتشغيلها.",
  "Deploying and managing websites and their hosting settings.":
    "نشر المواقع وإدارتها وضبط إعدادات الاستضافة.",
  "Moving websites and databases to new servers, with backups and checks to minimize downtime.":
    "نقل المواقع وقواعد بياناتها إلى خوادم جديدة، مع النسخ الاحتياطي والتحقق من التشغيل لتقليل الانقطاع.",
  "Skills & Technologies": "المهارات والتقنيات",
  "Software Solution Development": "تطوير الحلول البرمجية",
  "Systems analysis and design": "تحليل وتصميم النظم",
  "Administrative process automation": "أتمتة الإجراءات الإدارية",
  "MySQL database design": "هيكلة قواعد البيانات MySQL",
  "Web application development (PHP)": "تطوير تطبيقات ويب (PHP)",
  "Linux environment management": "إدارة بيئات Linux",
  "SSH connections": "بروتوكولات الاتصال SSH",
  "Caddy web server": "خوادم الويب Caddy Server",
  "Hosting management and deployment": "إدارة ونشر الاستضافات",
  "Link coming soon": "الرابط قريبًا",
  Darajat: "برنامج درجات",
  "A school administration program for managing grades and issuing graduation confirmations.":
    "برنامج إداري موجّه للمدارس لإدارة الدرجات وإصدار تأييدات التخرج.",
  "School grade management": "إدارة الدرجات المدرسية",
  "Issuing graduation confirmations": "إصدار تأييدات التخرج",
  Home: "الرئيسية",
  Education: "التعليم",
  Experience: "الخبرات",
  Projects: "المشاريع",
  Products: "المنتجات",
  "Coming Soon": "قريبًا",
  "Product Features": "ميزات المنتج",
  Download: "تحميل",
  "Back to Products": "العودة إلى المنتجات",
  "Personal Projects": "المشاريع الشخصية",
  "Madali Bot": "بوت معدلي",
  "SnapDoc Bot": "بوت سناب دوك",
  "An interactive digital assistant for students to navigate central college admissions and calculate GPAs.":
    "مساعد إلكتروني تفاعلي للطلبة لمعرفة تفاصيل القبول المركزي وحساب المعدل.",
  "An interactive Telegram assistant for translating text in images and converting PDF and Word files.":
    "مساعد تيليجرام تفاعلي لترجمة النصوص داخل الصور وتحويل صيغ ملفات PDF وWord.",
  "Open Source": "المصدر المفتوح",
  "Contact Me": "تواصل معي",
  "Contact Information": "بيانات الاتصال",
  "Direct Contact": "تواصل مباشر",
  "Message via WhatsApp": "مراسلة عبر واتساب",
  Phone: "الهاتف",
  "Primary Email": "البريد الرئيسي",
  "Alternative Email": "البريد البديل",
  "What I Do?": "ماذا أقدّم؟",
  "Degrees Received": "المؤهلات العلمية",
  Certifications: "الشهادات",
  "Basic Qualification and Certifcations": "المؤهلات الأساسية والشهادات",
  "Academic Qualifications": "المؤهلات العلمية",
  Contributions: "المساهمات",
  "Contributed Organizations": "الجهات التي ساهمت معها",
  "Pull Requests": "طلبات الدمج",
  Issues: "المشكلات",
  "Issue Distribution": "توزيع المشكلات",
  "Pull Request Distribution": "توزيع طلبات الدمج",
  Open: "مفتوح",
  Closed: "مغلق",
  Merged: "مدمج",
  "Files Changed": "الملفات المعدّلة",
  Repository: "المستودع",
  "opened on": "فُتح في",
  "More Projects": "المزيد من المشاريع",
  "Open Source Projects": "مشاريع مفتوحة المصدر",
  Publications: "المنشورات",
  "Project & Work History": "سجل المشاريع والأعمال العملية",
  "Sina University Website Migration":
    "نقل الموقع الإلكتروني لجامعة سينا المصرية",
  "Saudi Arabia Local Guide Application": "تطبيق الدليل المحلي للسعودية",
  "Apartment Reservation Management System": "نظام حجوزات الوحدات السكنية",
  "Configured and provisioned the new server, executing a secure, zero-downtime migration of the entire website and database to maintain continuous operational service.":
    "تهيئة وإعداد الخادم الجديد وتنفيذ عملية النقل الآمن للموقع الإلكتروني وقواعد البيانات بالكامل لضمان تشغيل الخدمة بسلامة ودون انقطاع.",
  "Developed the application interfaces and integrated them with database backends while enhancing performance speeds, offering an intuitive design tailored to local users.":
    "تطوير واجهات التطبيق وربطها بقواعد البيانات مع رفع الكفاءة والسرعة وتقديم تصميم يتناسب مع أفضل تجارب المستخدم المحلّي.",
  "End-to-end design and development of an intelligent booking system, featuring an interactive administrative dashboard to monitor vacancy statuses and handle reservations utilizing PHP and MySQL.":
    "تصميم وتطوير متكامل لنظام حجوزات ذكي يشمل لوحة تحكم إدارية تفاعلية للتحكم بالوحدات الشاغرة وحالة الحجز بالاعتماد على PHP وMySQL.",
  "View Review": "مراجعة التقييم",
  stars: "نجوم",
  "See My Resume": "عرض سيرتي الذاتية",
  "Visit My Blogsite": "زيارة مدونتي",
  "Visit on Google Maps": "عرض الموقع على خرائط Google",
  "Visit Website": "زيارة الموقع",
  Certificate: "الشهادة",
  "⭐ Star Me On Github": "⭐ أضف نجمة للمشروع على GitHub",
  "📃 Download Resume": "📃 تنزيل السيرة الذاتية",
  "Loading resume...": "جارٍ تحميل السيرة الذاتية...",
  "Failed to load resume. Please try again later.":
    "تعذر تحميل السيرة الذاتية. يرجى المحاولة لاحقًا.",
  "Try Again": "إعادة المحاولة",
  "Reload resume": "إعادة تحميل السيرة الذاتية",
  "Previous page": "الصفحة السابقة",
  "Next page": "الصفحة التالية",
  Previous: "السابق",
  Next: "التالي",
  Page: "الصفحة",
  of: "من",
  "Go up": "العودة إلى الأعلى",
  Woops: "عذرًا",
  "The requested page is unavailable at the moment!":
    "الصفحة المطلوبة غير متاحة حاليًا!",
  "Go Home": "العودة إلى الرئيسية",
  "Made with": "صُنع بكل",
  by: "بواسطة",
  "Created on": "تاريخ الإنشاء",
  "Published on": "تاريخ النشر",
  "Software Solutions & Business Simplification":
    "الحلول البرمجية وتبسيط الأعمال",
  "Full Stack Development": "تطوير البرمجيات المتكامل",
  "Cloud Infra-Architecture": "هندسة البنية التحتية السحابية",
  "Samer Jasim": "سامر جاسم",
  "Software Solutions Developer": "مطور حلول برمجية",
  "Specialized in requirements analysis, design, and development of administrative and educational systems. I transform operational needs into practical software solutions that improve efficiency and reduce time and effort.":
    "متخصص في تحليل المتطلبات وتصميم وتطوير الأنظمة الإدارية والتعليمية. أعمل على تحويل الاحتياجات التشغيلية إلى حلول برمجية عملية ترفع كفاءة العمل وتقلل الوقت والجهد.",
  "Samer Jasim | Software Solutions Developer": "سامر جاسم | مطور حلول برمجية",
  "Samer Jasim Portfolio": "الموقع الشخصي لسامر جاسم",
  "Portfolio of Samer Jasim, a software solutions developer specializing in administrative and educational systems, web development, databases, servers, and hosting.":
    "الموقع الشخصي لسامر جاسم، مطور حلول برمجية متخصص في الأنظمة الإدارية والتعليمية وتطوير الويب وقواعد البيانات والخوادم والاستضافة.",
  "Bachelor's Degree in the College of Science": "بكالوريوس في كلية العلوم",
  "Class Rank: 4": "التسلسل: 4",
  "Work, Internship and Volunteership": "العمل والتدريب والتطوع",
  "Work & Volunteering": "العمل والتطوع",
  "Government Employee": "موظف حكومي",
  "Ministry of Education": "وزارة التربية",
  "Transforming routine procedures into practical software solutions that reduce effort and time, improve efficiency, and speed up transactions.":
    "تحويل الإجراءات الروتينية إلى حلول برمجية عملية تقلل الجهد والوقت، وترفع كفاءة العمل وتسرّع إنجاز المعاملات.",
  "Preparing, organizing, archiving, and tracking incoming and outgoing official correspondence.":
    "إعداد الكتب والمراسلات الرسمية وتنظيم الصادر والوارد وأرشفته ومتابعته.",
  "Receiving students and employees, answering inquiries, and guiding them through the appropriate administrative procedures.":
    "استقبال الطلبة والموظفين والإجابة عن استفساراتهم وتوجيههم إلى الإجراءات الإدارية المناسبة.",
  "Following up on graduate and employee transactions while organizing student records and updating related data.":
    "متابعة معاملات الخريجين والموظفين، وتنظيم قيود الطلبة وتحديث البيانات والسجلات المرتبطة بها.",
  Work: "العمل",
  Internships: "التدريب",
  Volunteerships: "التطوع",
  "Machine Learning Engineer": "مهندس تعلم آلي",
  "Associate AI Engineer": "مهندس ذكاء اصطناعي مشارك",
  "Android and ML Developer": "مطور Android وتعلم آلي",
  "Android Developer": "مطور Android",
  "Machine Learning Intern": "متدرب تعلم آلي",
  "Data Science Research Intern": "متدرب أبحاث علم البيانات",
  "Data Science Intern": "متدرب علم بيانات",
  "Work From Home": "عمل عن بُعد",
  "Some of my published Articles, Blogs and Research.":
    "مجموعة من مقالاتي وتدويناتي وأبحاثي المنشورة.",
  "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.":
    "تستخدم مشاريعي مجموعة واسعة من التقنيات الحديثة، مع تركيز على بناء مشاريع علم البيانات ونشرها كتطبيقات ويب عبر البنية التحتية السحابية.",
  "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android, Cloud and Opensource Development.":
    "أنا متاح عبر معظم منصات التواصل. يمكنك مراسلتي وسأرد خلال 24 ساعة. يمكنني مساعدتك في تعلم الآلة والذكاء الاصطناعي وReact وAndroid والحوسبة السحابية وتطوير البرمجيات مفتوحة المصدر.",
  Blogs: "المدونة",
  "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.":
    "أحب توثيق تجاربي المهنية ومشاركة المعرفة التقنية التي أكتسبها خلال مسيرتي.",
  Address: "العنوان",
  "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.":
    "شخص شغوف ببناء منتجات متكاملة وأنظمة تقنية واجتماعية مستدامة وقابلة للتوسع تصنع أثرًا حقيقيًا.",
  "Developing custom software solutions that streamline daily operations and turn complex procedures into simpler, clearer steps":
    "تطوير حلول برمجية مخصصة لتسهيل الأعمال اليومية وتحويل الإجراءات المعقدة إلى خطوات أبسط وأكثر وضوحًا",
  "Automating repetitive administrative tasks such as data entry, record organization, search, follow-up, reporting, and document generation":
    "أتمتة المهام الإدارية المتكررة مثل إدخال البيانات، تنظيم السجلات، البحث، المتابعة، إعداد التقارير وإصدار المستندات",
  "Reducing manual work and errors while improving task completion speed through practical, easy-to-use systems":
    "تقليل العمل اليدوي والأخطاء وتحسين سرعة إنجاز المهام من خلال أنظمة عملية وسهلة الاستخدام",
  "Organizing data and workflows to make information easier to access, work easier to track, and decisions faster to make":
    "تنظيم البيانات وسير العمل بطريقة تساعد على الوصول للمعلومات ومتابعة الأعمال واتخاذ القرارات بشكل أسرع",
  "Building scalable and adaptable solutions that fit the needs of individuals, organizations, and different work environments":
    "بناء حلول قابلة للتطوير والتعديل بما يتناسب مع احتياجات الأفراد والمؤسسات وطبيعة العمل المختلفة",
  "Building and developing modern, responsive websites with a focus on usability, performance, and user experience":
    "بناء وتطوير مواقع ويب حديثة ومتجاوبة، مع التركيز على سهولة الاستخدام والأداء وتجربة المستخدم",
  "Developing mobile applications for Android and iOS":
    "تطوير تطبيقات الهاتف الذكي لأنظمة Android وiOS",
  "Developing desktop applications and custom software solutions tailored to business needs":
    "تطوير برامج سطح المكتب وحلول البرمجيات المخصصة حسب احتياجات العمل",
  "Developing back-end systems and APIs using Node.js, Express, and PHP":
    "تطوير الأنظمة الخلفية وواجهات API باستخدام Node.js وExpress وPHP",
  "Experience working on multiple cloud platforms":
    "خبرة في العمل على منصات سحابية متعددة",
  "Hosting and maintaining websites on virtual machine instances along with integration of databases":
    "استضافة المواقع وصيانتها على الخوادم الافتراضية وربطها بقواعد البيانات",
  "Deploying deep learning models on cloud to use on mobile devices":
    "نشر نماذج التعلم العميق على السحابة لاستخدامها على الأجهزة المحمولة",
  "Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS":
    "إعداد تدفقات البيانات بين قواعد البيانات والخوادم على GCP وAWS",
};

const monthTranslations = {
  January: "يناير",
  February: "فبراير",
  March: "مارس",
  April: "أبريل",
  May: "مايو",
  June: "يونيو",
  July: "يوليو",
  August: "أغسطس",
  Aug: "أغسطس",
  September: "سبتمبر",
  Sept: "سبتمبر",
  October: "أكتوبر",
  Oct: "أكتوبر",
  November: "نوفمبر",
  Nov: "نوفمبر",
  December: "ديسمبر",
  Dec: "ديسمبر",
  Present: "حتى الآن",
  PRESENT: "حتى الآن",
};

export const LanguageContext = React.createContext({
  language: "ar",
  direction: "rtl",
  toggleLanguage: () => {},
});

export function getInitialLanguage() {
  try {
    const savedLanguage = window.localStorage.getItem(STORAGE_KEY);
    if (SUPPORTED_LANGUAGES.includes(savedLanguage)) return savedLanguage;
  } catch (error) {
    // Local storage can be unavailable in privacy-focused browser modes.
  }

  return "ar";
}

export function setActiveLanguage(language) {
  activeLanguage = SUPPORTED_LANGUAGES.includes(language) ? language : "ar";

  if (typeof document !== "undefined") {
    document.documentElement.lang = activeLanguage;
    document.documentElement.dir = activeLanguage === "ar" ? "rtl" : "ltr";
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, activeLanguage);
  } catch (error) {
    // The language still works for the current session without persistence.
  }
}

export function getActiveLanguage() {
  return activeLanguage;
}

export function translate(value) {
  if (activeLanguage !== "ar" || typeof value !== "string") return value;

  const leadingSymbolMatch = value.match(/^(⚡\s*)/);
  const leadingSymbol = leadingSymbolMatch ? leadingSymbolMatch[0] : "";
  const text = leadingSymbol ? value.slice(leadingSymbol.length) : value;
  let translated = arabicTranslations[text] || text;

  Object.keys(monthTranslations).forEach((month) => {
    translated = translated.replace(
      new RegExp(`\\b${month}\\b`, "g"),
      monthTranslations[month]
    );
  });

  return `${leadingSymbol}${translated}`;
}

const proxyCache = new WeakMap();

export function localizeData(value) {
  if (!value || typeof value !== "object") return value;
  if (proxyCache.has(value)) return proxyCache.get(value);

  const proxy = new Proxy(value, {
    get(target, property, receiver) {
      const result = Reflect.get(target, property, receiver);
      if (typeof result === "string") return translate(result);
      if (result && typeof result === "object") return localizeData(result);
      return result;
    },
  });

  proxyCache.set(value, proxy);
  return proxy;
}
